module.exports = __webpack_public_path__ + "img/adminprogramme1.4db7e2c0.png";